$(function() {
  //November 17, 2015 - 10am ET
  var nextYear = moment.tz("2023-07-31 23:59", "US/Pacific");

  $('#clockdown').countdown(nextYear.toDate(), function(event) {
    var $this = $(this).html(event.strftime(''
                                            + '<span>%D</span> DAYS '
                                            + '<span>%H</span> HR '
                                            + '<span>%M</span> MIN '
                                            + '<span>%S</span> SEC'));
  });
});
